import React from 'react'
import { CommentsRoot, ReviewColumn, ReviewGrid, TagButton } from './Comments.styles'
import { useState } from 'react'
import { Stack } from 'components/Stack'
import { useTranslation } from 'hooks/useTranslation'
import { Tag } from 'fixtures/review'
import { ReviewType } from 'fixtures/review'
import { ReviewCard } from './components/ReviewCard'
import { useReviews } from 'hooks/useReviews'
import { Button } from 'components/Button'

export const Comments: React.FC = () => {
  const { t } = useTranslation()

  const reviews = useReviews()
  
  const [tag, setTag] = useState<Tag>('all')
  const [filteredReviews, setFilteredReviews] = useState(reviews)
  const [showMore, setShowMore] = useState(false)

  type ButtonTagType = {
    label: string
    tag: Tag
  }

  const ButtonTags: ButtonTagType[] = [
    { label: t('reviews:customers.tags.all'), tag: 'all' },
    { label: t('reviews:customers.tags.mealtime'), tag: 'mealtime excitement' },
    { label: t('reviews:customers.tags.weightManagement'), tag: 'weight management' },
    { label: t('reviews:customers.tags.longevity'), tag: 'longevity' },
    { label: t('reviews:customers.tags.healthyCoat'), tag: 'healthy coat' },
    { label: t('reviews:customers.tags.betterDigestion'), tag: 'better digestion' },
  ]

  const handleTag = (newTag: Tag) => {
    setTag(newTag)
    const newFilteredReviews = reviews.filter(
      (review) => newTag === 'all' || review.tag === newTag
    )
    setFilteredReviews(newFilteredReviews)
  }

  type MasonryType = { cards: ReviewType[] }

  const Masonry = ({ cards }: MasonryType) => {
    const numCards = cards.length
    const rows = Math.ceil(numCards / 3)
    const lastColIndex = numCards % 3
    const firstColLength = rows
    const secondColLength = lastColIndex === 1 ? rows - 1 : rows

    return (
      <ReviewGrid className="desktop-only">
        <ReviewColumn>
          {cards.slice(0, firstColLength).map((card, i) => (
            <ReviewCard key={card.owner} review={card} />
          ))}
        </ReviewColumn>
        <ReviewColumn>
          {cards.slice(firstColLength, firstColLength + secondColLength).map((card, i) => (
            <ReviewCard key={card.owner} review={card} />
          ))}
        </ReviewColumn>
        <ReviewColumn>
          {cards.slice(firstColLength + secondColLength).map((card, i) => (
            <ReviewCard key={card.owner} review={card} />
          ))}
        </ReviewColumn>
      </ReviewGrid>
    )
  }

  const ReviewPageReviewsMobile = ({ cards }: MasonryType) => {
    return (
      <>
        {cards.map((card) => (
          <ReviewCard key={card.owner} review={card} />
        ))}
      </>
    )
  }

  const ShowMoreButton = () => {

    const ShowMore = () => (
      <Button onClick={() => setShowMore((prev) => !prev)} variant="secondaryAlt">
        {t('reviews:customers.load')}
      </Button>
    )

    const ButtonStack = ({ isMobileOnly = false }: { isMobileOnly?: boolean }) => {
      const limit = isMobileOnly ? 7 : 12

      return (
        <Stack
          display={
            isMobileOnly
              ? { '@initial': 'flex', '@bp3': 'none' }
              : { '@initial': 'none', '@bp3': 'flex' }
          }
          css={{ margin: '32px 0px' }}
          justifyContent="center"
        >
          {filteredReviews.length > limit && !showMore && <ShowMore />}
        </Stack>
      )
    }

    return (
      <>
        <ButtonStack isMobileOnly />
        <ButtonStack />
      </>
    )
  }

  return (
    <CommentsRoot>
      <Stack
        css={{ rowGap: '$2', marginBottom: '$8' }}
        direction="wrap"
        gap="1"
        justifyContent="center"
      >
        {ButtonTags.map((buttonTag, index) => (
          <TagButton
            onClick={() => handleTag(buttonTag.tag)}
            key={index}
            active={tag === buttonTag.tag}
          >
            {buttonTag.label}
          </TagButton>
        ))}
      </Stack>
      <Masonry cards={showMore ? filteredReviews : filteredReviews.slice(0, 12)} />
      <Stack
        display={{ '@initial': 'flex', '@bp3': 'none' }}
        justifyContent="center"
        direction="column"
        alignItems="center"
        gap="2"
      >
        <ReviewPageReviewsMobile cards={showMore ? filteredReviews : filteredReviews.slice(0, 7)} />
      </Stack>
      <ShowMoreButton />
    </CommentsRoot>
  )
}
